import { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";
import { HelpCircle, Trash2, Send, Ban } from "lucide-react";
import { fmtDate  } from "../../lib/format";
import { errText } from "../../lib/errors";

const TABS = [["bekliyor", "Yanıt Bekleyen"], ["yanitlandi", "Yanıtlanan"], ["kapali", "Kapatılan"], ["", "Tümü"]];

export default function AdminQuestions() {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("bekliyor");
  const [open, setOpen] = useState(null);
  const [answer, setAnswer] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/admin/questions", { params: tab ? { status: tab } : {} }).then(({ data }) => setItems(data)).catch(() => {});
  useEffect(load, [tab]);

  const save = async (q, status = "yanitlandi") => {
    if (status === "yanitlandi" && !answer.trim()) { toast.warning("Yanıt yazın"); return; }
    setBusy(true);
    try {
      await api.put(`/admin/questions/${q.question_id}`, { answer, status });
      toast.success(status === "yanitlandi" ? "Yanıt yayınlandı" : "Soru kapatıldı");
      setOpen(null); setAnswer(""); load();
    } catch (e) { toast.error(errText(e) || "Kaydedilemedi"); }
    finally { setBusy(false); }
  };

  const del = async (q) => {
    if (!window.confirm("Soru kalıcı olarak silinsin mi?")) return;
    try {
      await api.delete(`/admin/questions/${q.question_id}`);
      toast.success("Soru silindi");
      load();
    } catch { toast.error("Silinemedi"); }
  };

  return (
    <div data-testid="admin-questions-page" className="space-y-6">
      <div>
        <h1 className="font-serif text-2xl sm:text-3xl text-forest">Ürün Soru & Cevap</h1>
        <p className="text-stone-500 text-sm mt-1">Müşterilerin ürün sayfalarından sorduğu sorular. Yanıtlanan sorular ürün sayfasında herkese görünür.</p>
      </div>

      <div className="flex flex-wrap gap-2">
        {TABS.map(([k, label]) => (
          <button key={k} data-testid={`qa-tab-${k || "all"}`} onClick={() => setTab(k)} className={`px-3.5 py-2 rounded-xl text-xs font-semibold transition-colors ${tab === k ? "bg-forest text-white" : "bg-white border border-stone-200 text-stone-600 hover:bg-stone-50"}`}>{label}</button>
        ))}
      </div>

      <div className="space-y-3">
        {items.length === 0 && <div className="bg-white rounded-2xl border border-stone-200/80 p-10 text-center text-stone-400 text-sm"><HelpCircle className="w-8 h-8 mx-auto mb-2 opacity-40" />Bu durumda soru yok</div>}
        {items.map((q) => (
          <div key={q.question_id} data-testid={`qa-row-${q.question_id}`} className="bg-white rounded-2xl border border-stone-200/80 p-5 shadow-sm">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <p className="text-xs text-stone-400">{q.product_name} · {q.name} · {fmtDate(q.created_at)}</p>
                <p className="mt-1.5 text-sm font-semibold text-stone-800">{q.question}</p>
                {q.answer && <p className="mt-2 text-sm text-stone-600 bg-cream-dark/60 rounded-xl p-3"><span className="font-semibold text-forest">Yanıt:</span> {q.answer}</p>}
              </div>
              <div className="flex gap-1.5 shrink-0">
                {q.status !== "yanitlandi" && (
                  <button data-testid={`qa-open-${q.question_id}`} onClick={() => { setOpen(open === q.question_id ? null : q.question_id); setAnswer(q.answer || ""); }} className="text-xs font-semibold bg-forest hover:bg-forest-dark text-white px-3 py-2 rounded-lg transition-colors">Yanıtla</button>
                )}
                {q.status !== "kapali" && (
                  <button data-testid={`qa-close-${q.question_id}`} onClick={() => save(q, "kapali")} className="p-2 border border-stone-200 hover:bg-stone-50 rounded-lg text-stone-500" title="Yayınsız kapat"><Ban className="w-4 h-4" /></button>
                )}
                <button data-testid={`qa-del-${q.question_id}`} onClick={() => del(q)} className="p-2 border border-red-200 hover:bg-red-50 rounded-lg text-terra" title="Sil"><Trash2 className="w-4 h-4" /></button>
              </div>
            </div>
            {open === q.question_id && (
              <div className="mt-3 flex gap-2">
                <textarea data-testid={`qa-answer-${q.question_id}`} rows={2} className="flex-1 px-4 py-2.5 rounded-xl border border-stone-300 text-sm focus:outline-none focus:ring-2 focus:ring-forest/30" placeholder="Yanıtınız (ürün sayfasında herkese görünür)..." value={answer} onChange={(e) => setAnswer(e.target.value)} />
                <button data-testid={`qa-save-${q.question_id}`} onClick={() => save(q)} disabled={busy} className="self-end flex items-center gap-1.5 bg-gold hover:bg-gold-dark disabled:bg-stone-400 text-stone-900 text-xs font-semibold px-4 py-2.5 rounded-xl transition-colors"><Send className="w-3.5 h-3.5" /> Yayınla</button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
